"use client";

import { useSidebarContext } from "../../contexts/SidebarContext";
import SidebarTreeItem from "./SidebarTreeItem";

interface SidebarTreeProps {
  parentId: string | null;
  level?: number;
  section: string;
}

export default function SidebarTree({ parentId = null, level = 0, section }: SidebarTreeProps) {
  const { docs } = useSidebarContext();

  const currentLevelDocs = (docs as any[])
    .filter(d => d.parentId === parentId)
    .sort((a, b) => {
      const posA = a.position ?? 0;
      const posB = b.position ?? 0;
      if (posA !== posB) return posA - posB;
      return new Date(a.createdAt ?? 0).getTime() - new Date(b.createdAt ?? 0).getTime();
    });

  if (currentLevelDocs.length === 0) return null;

  return (
    <>
      {currentLevelDocs.map((doc: any) => (
        <SidebarTreeItem key={`${section}-${doc.id}`} doc={doc} level={level} section={section} />
      ))}
    </>
  );
}
